import { absoluteUrl } from "@/lib/site";

export type BreadcrumbItem = {
  label: string;
  path: string;
};

export function homeBreadcrumb(): BreadcrumbItem {
  return { label: "Home", path: "/" };
}

export function commercialBreadcrumbTrail(pageLabel: string, pagePath: string): BreadcrumbItem[] {
  return [
    homeBreadcrumb(),
    { label: "Commercial", path: "/commercial" },
    { label: pageLabel, path: pagePath },
  ];
}

export function servicesBreadcrumbTrail(pageLabel: string, pagePath: string): BreadcrumbItem[] {
  return [
    homeBreadcrumb(),
    { label: "Services", path: "/services" },
    { label: pageLabel, path: pagePath },
  ];
}

export function contentBreadcrumbTrail(pageLabel: string, pagePath: string): BreadcrumbItem[] {
  return [
    homeBreadcrumb(),
    { label: "Content", path: "/content" },
    { label: pageLabel, path: pagePath },
  ];
}

export function breadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: absoluteUrl(item.path),
    })),
  };
}

export function breadcrumbJsonLdScript(items: BreadcrumbItem[]) {
  return {
    type: "application/ld+json" as const,
    children: JSON.stringify(breadcrumbJsonLd(items)),
  };
}
